import { Badge } from '@design/components/badge/Badge';
import { Tooltip } from '@design/components/tooltip/Tooltip';
import { CSSProperties } from 'react';

import styles from './AxisUnit.module.scss';

export interface AxisUnitProps {
  label: string;
  tooltipLabel: string;
  isMixed: boolean;
  gutterWidth: number;
  top: number;
  offset?: number;
}

export const AxisUnit = ({
  top,
  label,
  tooltipLabel,
  isMixed,
  offset,
  gutterWidth,
}: AxisUnitProps) => {
  const containerStyle: CSSProperties = {
    width: `${gutterWidth}px`,
    right: offset ? `${offset}px` : 0,
    top: `${top}px`,
  };

  return (
    <div
      className={styles.container}
      style={containerStyle}
      data-testid="axis-unit-root"
    >
      <Tooltip
        label={tooltipLabel}
        isTouchDevice={false}
        closeLabel=""
        disabled={!isMixed}
        inPortal
      >
        <Badge
          className={styles.badge}
          label={
            <span className={styles.label} data-testid="unit-badge">
              {label}
            </span>
          }
          color="neutral"
          badgeStyle="outline"
          size="small"
        />
      </Tooltip>
    </div>
  );
};
